import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, ReactiveFormsModule, MatDialogModule, MatInputModule, MatFormFieldModule, MatCheckboxModule],
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  // @ViewChild('colorPicker') colorPicker: NgxMatColorPickerComponent;
  // colorPickerControls: "default" | "only-alpha" | "no-alpha" = "no-alpha";

  public form: FormGroup = this.formBuilder.group({});
  public isDangerConfirm: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private readonly formBuilder: FormBuilder,
    private dialog: MatDialogRef<ConfirmDialogComponent>
    ) {
    if (typeof data.showIcon == 'undefined') { data.showIcon = true; }

    if (data.type === 'danger') {
      this.isDangerConfirm = true;
      this.form.addControl('dangerConfirmCheck', new FormControl(false, [Validators.requiredTrue]));
    }

    if (typeof data.inputs != 'undefined' && data.inputs.length > 0) {
      for (let control of data.inputs) {
        let validators: ValidatorFn[] = [];
        if (control.validators) {
          validators = control.validators;
        }
        this.form.addControl(control.name, new FormControl(control.value, validators));
      }
    }
  }

  // updateColor(ev) {
  //   this.form.controls.color.setValue(ev)
  //   this.form.controls.colorPckr.setValue(ev)
  // }

  close(action) {
    this.dialog.close({
      action: action,
      form: this.form
    })

  }
}

export interface ConfirmDialogData {
  title: string;
  message: string;
  type: "danger" | "warning" | "info" | "edit" | "success";
  inputs?: any[];
  confirmText: string;
  cancelText?: string;
  secondaryActionText?: string;
  showIcon?: boolean;
}